// Modul Products – i18n manifest (veřejný kontrakt pro composition).
// Skládá vlastní `products` namespace + namespaces submodulů (venua-planner, columbus-planner).
// Submoduly si vlastní locale bundle drží u sebe (mají vlastní i18n manifest i pro test harness);
// modulový manifest je jen agreguje, aby composition vrstva sahala jen na úrovni modulu.

import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';
import { venuaPlannerI18nManifest } from './venua-planner';
import { columbusI18nManifest } from './columbus-planner';

const NS = 'products';

export const productsI18nManifest: SliceI18nManifest = {
  owner: 'modules/products',
  namespaces: [NS, ...venuaPlannerI18nManifest.namespaces, ...columbusI18nManifest.namespaces],
  resources: {
    cs: {
      [NS]: cs,
      ...(venuaPlannerI18nManifest.resources['cs'] ?? {}),
      ...(columbusI18nManifest.resources['cs'] ?? {}),
    },
    en: {
      [NS]: en,
      ...(venuaPlannerI18nManifest.resources['en'] ?? {}),
      ...(columbusI18nManifest.resources['en'] ?? {}),
    },
  },
};
